/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectsControllerFindByScopeIdQueryResponse, ProjectsControllerFindByScopeIdPathParams, ProjectsControllerFindByScopeIdQueryParams, ProjectsControllerFindByScopeId400, ProjectsControllerFindByScopeId401, ProjectsControllerFindByScopeId403, ProjectsControllerFindByScopeId404 } from "../../models/projectsController/ProjectsControllerFindByScopeId";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { projectsControllerFindByScopeId } from "../../clients/projectsService/projectsControllerFindByScopeId";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const projectsControllerFindByScopeIdQueryKey = (scopeId: ProjectsControllerFindByScopeIdPathParams["scopeId"], params: ProjectsControllerFindByScopeIdQueryParams = {}) => [{
  url: '/api/v1/scopes/:scopeId/project',
  params: {
    scopeId: scopeId
  }
}, ...(params ? [params] : [])] as const;
export type ProjectsControllerFindByScopeIdQueryKey = ReturnType<typeof projectsControllerFindByScopeIdQueryKey>;
export function projectsControllerFindByScopeIdQueryOptions(scopeId: ProjectsControllerFindByScopeIdPathParams["scopeId"], params?: ProjectsControllerFindByScopeIdQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = projectsControllerFindByScopeIdQueryKey(scopeId, params);
  return queryOptions<ProjectsControllerFindByScopeIdQueryResponse, ResponseErrorConfig<ProjectsControllerFindByScopeId400 | ProjectsControllerFindByScopeId401 | ProjectsControllerFindByScopeId403 | ProjectsControllerFindByScopeId404>, ProjectsControllerFindByScopeIdQueryResponse, typeof queryKey>({
    enabled: !!scopeId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return projectsControllerFindByScopeId(scopeId, params, config);
    }
  });
}

/**
 * @summary Get a project by scope ID
 * {@link /api/v1/scopes/:scopeId/project}
 */
export function useProjectsControllerFindByScopeId<TData = ProjectsControllerFindByScopeIdQueryResponse, TQueryData = ProjectsControllerFindByScopeIdQueryResponse, TQueryKey extends QueryKey = ProjectsControllerFindByScopeIdQueryKey>(scopeId: ProjectsControllerFindByScopeIdPathParams["scopeId"], params?: ProjectsControllerFindByScopeIdQueryParams, options: {
  query?: Partial<QueryObserverOptions<ProjectsControllerFindByScopeIdQueryResponse, ResponseErrorConfig<ProjectsControllerFindByScopeId400 | ProjectsControllerFindByScopeId401 | ProjectsControllerFindByScopeId403 | ProjectsControllerFindByScopeId404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? projectsControllerFindByScopeIdQueryKey(scopeId, params);
  const query = useQuery({
    ...projectsControllerFindByScopeIdQueryOptions(scopeId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ProjectsControllerFindByScopeId400 | ProjectsControllerFindByScopeId401 | ProjectsControllerFindByScopeId403 | ProjectsControllerFindByScopeId404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}